import { z } from "zod";

import { nodeActionSchema } from "../actions/index.ts";
import { contentLanguageSchema } from "../languages/index.ts";
import { semverSchema } from "../shared/index.ts";
import { nodeDesignsStateSchema } from "./nodeDesignsStateSchema.ts";

export const nodeDesignsRevisionSchema = z.object({
  actions: z.array(nodeActionSchema),
  revision: z.number(),
  createdOn: z.date({ coerce: true }),
  skip: z.boolean().nullish(),
  checksum: z.number().int().nullish(),
});

export type NodeDesignsRevision = z.infer<typeof nodeDesignsRevisionSchema>;

export const nodeDesignsEntitySchema = z.object({
  nodeDesigns: nodeDesignsStateSchema, // TODO: this is different for db entity vs response entity
  revision: z.number(),
  languages: z.array(contentLanguageSchema).readonly(),
  unappliedRevisions: z.array(nodeDesignsRevisionSchema),
  maxUnappliedRevisions: z.number(),
  appVersion: semverSchema,
});

export type NodeDesignsEntity = z.infer<typeof nodeDesignsEntitySchema>;
